import Tooltip from '@common/components/Tooltip'
import { IconButton, useTheme } from '@linagora/twake-mui'
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined'
import RefreshIcon from '@mui/icons-material/Refresh'
import { useState } from 'react'
import { useI18n } from 'twake-i18n'
import { AppListMenu } from './AppListMenu'
import { NavigationControls } from './components/NavigationControls'
import SearchBar from './EventSearchBar'
import { MainTitle } from './MainTitle'
import { SharedMenubarProps } from './Menubar'
import { SelectView } from './SelectView'
import { UserMenu } from './UserMenu'

export const DesktopMenubar: React.FC<SharedMenubarProps> = ({
  calendarRef,
  currentView,
  isIframe,
  dateLabel,
  supportLink,
  anchorEl,
  onAppMenuOpen,
  onAppMenuClose,
  onUserMenuOpen,
  onSettingsClick,
  onLogoutClick,
  onNavigate,
  onRefresh,
  onViewChange,
  onDateChange,
  user,
  userMenuAnchorEl,
  onUserMenuClose
}) => {
  const { t } = useI18n()
  const theme = useTheme()

  const [isSearchExpanded, setIsSearchExpanded] = useState(false)

  return (
    <header
      className="menubar"
      style={{ borderBottom: `1px solid ${theme.palette.divider}` }}
    >
      <div className="left-menu">
        {!isIframe && (
          <div className="menu-items">
            <MainTitle
              calendarRef={calendarRef}
              currentView={currentView}
              onViewChange={onViewChange}
              onDateChange={onDateChange}
            />
          </div>
        )}

        <div className="menu-items" style={{ marginLeft: '65px' }}>
          <NavigationControls onNavigate={onNavigate} />
        </div>

        {!isSearchExpanded && (
          <div className="menu-items">
            <div className="current-date-time">
              <p>{dateLabel}</p>
            </div>
          </div>
        )}
      </div>

      <div className="right-menu">
        <div
          className="search-container"
          style={{
            minWidth: 0
          }}
        >
          <SearchBar onToggleSearch={setIsSearchExpanded} />
        </div>

        <div className="menu-items">
          <Tooltip title={t('tooltip.refreshCalendar')}>
            <IconButton
              className="refresh-button"
              onClick={onRefresh}
              aria-label={t('menubar.refresh')}
              sx={{ mr: 1 }}
            >
              <RefreshIcon />
            </IconButton>
          </Tooltip>
        </div>

        <div className="menu-items">
          <SelectView currentView={currentView} onViewChange={onViewChange} />
        </div>

        {!isIframe && (
          <>
            {supportLink && (
              <div className="menu-items">
                <Tooltip title={t('menubar.help')}>
                  <IconButton
                    component="a"
                    href={supportLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ marginRight: 8 }}
                    aria-label={t('menubar.help')}
                  >
                    <HelpOutlineOutlinedIcon />
                  </IconButton>
                </Tooltip>
              </div>
            )}

            <div className="menu-items">
              <AppListMenu
                anchorEl={anchorEl}
                onAppMenuOpen={onAppMenuOpen}
                onAppMenuClose={onAppMenuClose}
              />
            </div>
          </>
        )}

        <div className="menu-items">
          <UserMenu
            anchorEl={userMenuAnchorEl}
            onClose={onUserMenuClose}
            onSettingsClick={onSettingsClick}
            onLogoutClick={onLogoutClick}
            onUserMenuOpen={onUserMenuOpen}
            isIframe={isIframe}
            user={user}
          />
        </div>
      </div>
    </header>
  )
}
